import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { StyledEngineProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import Routes from 'config/routes';

import './index.css';

function App() {
  return (
    <StyledEngineProvider>
      <CssBaseline />
      <Routes />
    </StyledEngineProvider>
  );
}

export default App;
